import React from 'react';

interface BadgeProps {
  bgClassName: string;
  textClassName: string;
  text: string;
}

function Badge({ bgClassName, textClassName, text }: BadgeProps) {
  return (
    <div className="flex">
      <div className={`px-2 py-1 ${bgClassName} rounded`}>
        <span className={`${textClassName} font-semibold`}>{text}</span>
      </div>
    </div>
  );
}

export default Badge;
